import { useEffect } from 'react';

import validate from './EmailFormValidation';

import UseForm from "@usas/ui-web/utils/UseForm";

const INITIAL_FORM_STATE = {
  email: ''
};

const useEmailForm = (onSubmitFormCallback, emailObj) => {
  const { formState, errorState, handleSubmit, updateFormState, resetForm, setFormData
  } = UseForm(INITIAL_FORM_STATE, onSubmitFormCallback, validate);

  useEffect(() => {
    if (emailObj) {
      setFormData({
        ...formState,
        email: emailObj.emailAddress || '',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [emailObj]);

  return {
    formState,
    errorState,
    handleSubmit,
    updateFormState,
    resetForm
  };
};

export default useEmailForm;